import * as React from "react";
import { sanitize } from "dompurify";

export interface IHtmlProps {
    html: string;
}

/**
 * Display html using React's dangerous innerHtml method. Note this assumes pre-sanitised html, which should occur server side
 * @param props html content props
 */
export const SanitisedHtml = (props: IHtmlProps) => {
    const clean = sanitize(props.html);
    return <div dangerouslySetInnerHTML={{__html: clean }} />
};


// WEBPACK FOOTER //
// ./src/components/html.tsx